import { render, staticRenderFns } from "./plan-clear-popup.html?vue&type=template&id=387dab8c&scoped=true&external"
import script from "./plan-clear-popup.js?vue&type=script&lang=js&external"
export * from "./plan-clear-popup.js?vue&type=script&lang=js&external"
import style0 from "./plan-clear-popup.scss?vue&type=style&index=0&id=387dab8c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387dab8c",
  null
  
)

export default component.exports